import StudentDashboardStats from '@/models/StudentDashboard';
import Unit from '@/models/Unit';
import StudentUnitShortcuts from './StudentUnitShortcuts';
import StudentUnitLessons from './StudentUnitLessons';
import UnitSection from './UnitSection';

type StudentUnitSectionProps = {
  unit: Unit;
  defaultOpen: boolean;
  courseProgress: StudentDashboardStats;
};

export default function StudentUnitSection({
  unit,
  defaultOpen,
  courseProgress,
}: StudentUnitSectionProps) {
  const { id: courseProgressId, coursePath, klassId } = courseProgress;
  const route = { slug: coursePath.slug, klassId };

  return (
    <UnitSection
      unit={unit}
      defaultOpen={defaultOpen}
      shortcuts={
        unit.contentLesson && (
          <StudentUnitShortcuts contentLesson={unit.contentLesson} {...route} />
        )
      }
    >
      <StudentUnitLessons
        unitId={unit.id}
        courseProgressId={courseProgressId}
        {...route}
      />
    </UnitSection>
  );
}
